import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const ReferencePersonIcon = ({
  color = RoutalPalette.grey1,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 17.01 17.01" style={{ width: `16px`, height: `16px`, color, ...props.style }}>
      <g>
        <path d="M16.42,16.82H.59c-.28,0-.5-.22-.5-.5v-1.98c0-2.46,2-4.46,4.46-4.46h7.92c2.46,0,4.46,2,4.46,4.46v1.98c0,.28-.22.5-.5.5ZM1.09,15.82h14.83v-1.48c0-1.91-1.55-3.46-3.46-3.46h-7.92c-1.91,0-3.46,1.55-3.46,3.46v1.48Z" />
        <path d="M8.5,9.11c-2.46,0-4.46-2-4.46-4.46S6.05.19,8.5.19s4.46,2,4.46,4.46-2,4.46-4.46,4.46ZM8.5,1.19c-1.91,0-3.46,1.55-3.46,3.46s1.55,3.46,3.46,3.46,3.46-1.55,3.46-3.46-1.55-3.46-3.46-3.46Z" />
      </g>
    </SvgIcon>
  );
};
